import { useLocation, useNavigate } from "react-router-dom";
import styles from "./JobDetails.module.css";
import { Spin } from "antd";

const dummayData = {
  img: "https://cdn.pixabay.com/photo/2022/09/18/07/41/logo-7462411_640.png",
  title: "Consultant - Deutsche Bank Management Consulting (DBMC) - Analyst",
  location: "Cisco – London",
  job_details: [
    {
      title: "DEUTSCHE BANK",
      value:
        "We believe talent is found in all cultures, countries, races, ethnicities, genders, sexual orientations, disabilities, beliefs, generations, backgrounds and experiences. We pursue a working environment where everyone can be authentic and feel a sense of belonging.",
    },
    {
      title: "DEUTSCHE BANK",
      value:
        "We believe talent is found in all cultures, countries, races, ethnicities, genders, sexual orientations, disabilities, beliefs, generations, backgrounds and experiences. We pursue a working environment where everyone can be authentic and feel a sense of belonging.",
    },
    {
      title: "DEUTSCHE BANK",
      value:
        "We believe talent is found in all cultures, countries, races, ethnicities, genders, sexual orientations, disabilities, beliefs, generations, backgrounds and experiences. We pursue a working environment where everyone can be authentic and feel a sense of belonging.",
    },

    {
      title: "DEUTSCHE BANK",
      value:
        "We believe talent is found in all cultures, countries, races, ethnicities, genders, sexual orientations, disabilities, beliefs, generations, backgrounds and experiences. We pursue a working environment where everyone can be authentic and feel a sense of belonging.",
    },
    {
      title: "DEUTSCHE BANK",
      value:
        "We believe talent is found in all cultures, countries, races, ethnicities, genders, sexual orientations, disabilities, beliefs, generations, backgrounds and experiences. We pursue a working environment where everyone can be authentic and feel a sense of belonging.",
    },
    {
      title: "DEUTSCHE BANK",
      value:
        "We believe talent is found in all cultures, countries, races, ethnicities, genders, sexual orientations, disabilities, beliefs, generations, backgrounds and experiences. We pursue a working environment where everyone can be authentic and feel a sense of belonging.",
    },
    {
      title: "DEUTSCHE BANK",
      value:
        "We believe talent is found in all cultures, countries, races, ethnicities, genders, sexual orientations, disabilities, beliefs, generations, backgrounds and experiences. We pursue a working environment where everyone can be authentic and feel a sense of belonging.",
    },
  ],
};

const JobDetails = ({ data }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const handleApply = () => {};

  const handleBack = () => {
    navigate(location.pathname.replace("job-description", "job"));
  };

  if (!data) {
    return (
      <div className={styles.content_wrap}>
        <Spin />
      </div>
    );
  }

  return (
    <div className={styles.content_wrap}>
      <div className={styles.header}>
        <img
          src={
            data && data.enterpriseData
              ? data.enterpriseData.companyImage.docs
              : dummayData.img
          }
          className={styles.img_wrap}
          alt="job img"
        />
        <div>
          <div className={styles.title}>{data.job_title}</div>
          <div className={styles.location}>{data.company}</div>
        </div>
      </div>
      <div>
        <div className={styles.content}>
          <div className={styles.content_title}>{data?.company}</div>
          <div className={styles.content_description}>{data?.company_bio}</div>
        </div>

        <div className={styles.content}>
          <div className={styles.content_title}>Role Overview</div>
          <div className={styles.content_description}>
            {data?.job_role_text}
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.content_title}>What We Offer You</div>
          <div className={styles.content_description}>
            {data?.company_benefits}
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.content_title}>What you'll do</div>
          <div className={styles.content_description}>
            {data?.job_expectation}
          </div>
        </div>
       
      </div>
      <div className={styles.btn_group}>
        <button onClick={handleApply}>Apply Now</button>
        <button onClick={handleBack}>Back</button>
      </div>
    </div>
  );
};

export default JobDetails;
